import { Fragment, useState } from "react";
import {
  clean,
  truncate,
  scoreColor,
  fitLabel,
  estimatedValue,
  suggestedAngle,
} from "../lib/format.js";

/** Secondary to the Decision card on purpose: this is the archive, not the advice. */
export default function ProspectTable({ opportunities, drafting, onDraft }) {
  const [showAll, setShowAll] = useState(false);
  const [expanded, setExpanded] = useState(null);
  const rows = showAll ? opportunities : opportunities.slice(0, 5);

  return (
    <div className="a a2" style={{ marginBottom: 20 }}>
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 8,
        }}
      >
        <div style={{ fontSize: 13, fontWeight: 600, color: "var(--t3)" }}>All prospects</div>
        <button
          onClick={() => setShowAll(!showAll)}
          style={{
            fontSize: 11,
            color: "var(--volt)",
            background: "transparent",
            border: "none",
            cursor: "pointer",
            fontWeight: 600,
          }}
        >
          {showAll ? "Top 5" : `View all (${opportunities.length})`}
        </button>
      </div>

      <div
        style={{
          background: "var(--s1)",
          border: "1px solid var(--brd)",
          borderRadius: 10,
          overflow: "hidden",
        }}
      >
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ borderBottom: "1px solid var(--brd)" }}>
              {["Score", "Prospect", "Why now", "Fit", ""].map((h, i) => (
                <th
                  key={i}
                  style={{
                    padding: "7px 14px",
                    fontSize: 9,
                    fontWeight: 700,
                    color: "var(--t3)",
                    letterSpacing: "0.08em",
                    textTransform: "uppercase",
                    textAlign: "left",
                  }}
                >
                  {h}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {rows.map((o) => (
              <Fragment key={o.id}>
                <tr
                  onClick={() => setExpanded(expanded === o.id ? null : o.id)}
                  style={{ borderBottom: "1px solid var(--brd)", cursor: "pointer" }}
                  onMouseEnter={(e) => (e.currentTarget.style.background = "var(--vg2)")}
                  onMouseLeave={(e) => (e.currentTarget.style.background = "transparent")}
                >
                  <td style={{ padding: "8px 14px", width: 50 }}>
                    <div
                      style={{
                        width: 32,
                        height: 32,
                        borderRadius: 8,
                        border: `1.5px solid ${scoreColor(o.score)}`,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontFamily: "var(--d)",
                        fontSize: 13,
                        fontWeight: 700,
                        color: scoreColor(o.score),
                      }}
                    >
                      {o.score}
                    </div>
                  </td>
                  <td style={{ padding: "9px 14px" }}>
                    <div style={{ fontSize: 14, fontWeight: 600 }}>{o.company}</div>
                    <div style={{ fontSize: 12, color: "var(--t3)" }}>{o.sector}</div>
                  </td>
                  <td style={{ padding: "8px 14px", maxWidth: 230 }}>
                    <div style={{ fontSize: 13, color: "var(--t2)", lineHeight: 1.45 }}>
                      {truncate(o.why_now, 70)}
                    </div>
                  </td>
                  <td style={{ padding: "8px 14px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      <div
                        style={{
                          width: 6,
                          height: 6,
                          borderRadius: "50%",
                          background: scoreColor(o.score),
                        }}
                      />
                      <span style={{ fontSize: 11, color: "var(--t2)" }}>{fitLabel(o.score)}</span>
                    </div>
                  </td>
                  <td style={{ padding: "8px 14px" }}>
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        onDraft(o);
                      }}
                      style={{
                        padding: "5px 11px",
                        borderRadius: 5,
                        border: "none",
                        background: "var(--vg)",
                        color: "var(--volt)",
                        fontSize: 10,
                        fontWeight: 600,
                        cursor: "pointer",
                        fontFamily: "var(--d)",
                      }}
                    >
                      {drafting === o.id ? "…" : "Draft"}
                    </button>
                  </td>
                </tr>

                {expanded === o.id && (
                  <tr>
                    <td colSpan="5" style={{ padding: "0 14px 10px", background: "var(--vg2)" }}>
                      <div
                        style={{
                          padding: 12,
                          borderRadius: 8,
                          background: "var(--s2)",
                          fontSize: 12,
                          color: "var(--t2)",
                          lineHeight: 1.5,
                        }}
                      >
                        <strong style={{ color: "var(--t1)" }}>{o.company}</strong> —{" "}
                        {clean(o.why_now)}
                        <div style={{ marginTop: 6, display: "flex", gap: 14, fontSize: 11 }}>
                          <span style={{ color: "var(--t3)" }}>
                            Est. value{" "}
                            <strong style={{ color: "var(--t1)" }}>{estimatedValue(o)}</strong>
                          </span>
                          <span style={{ color: "var(--t3)" }}>
                            Angle{" "}
                            <strong style={{ color: "var(--t1)" }}>{suggestedAngle(o)}</strong>
                          </span>
                        </div>
                        {o.contact && (
                          <div style={{ marginTop: 5, color: "var(--t3)", fontSize: 11 }}>
                            {o.contact.name}
                            {o.contact.email ? ` · ${o.contact.email}` : ""}
                          </div>
                        )}
                      </div>
                    </td>
                  </tr>
                )}
              </Fragment>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
